export default __webpack_public_path__ + "static/media/medical-lab.4ba1b942.svg";